import React from 'react';

import { generalConstants } from '../constants';

class Fileuploader extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
  }

  componentDidMount() {
    console.log('AntikodeUploaderReadyToServ....');
  }

  render() {
    const { file, label, name, file_onChange } = this.props;
    
    return (
      <div className="form-group">
        <label htmlFor="validationCustom05">{label}</label>
        <div className="custom-file">
          <input
            type="file"
            name={name}
            className="custom-file-input"
            id="validatedCustomFile"
            required
            onChange={file_onChange}
          />
          {file ? (
            <label className="custom-file-label" htmlFor="validatedCustomFile">
              {file.name}
            </label>
          ) : (
            <label className="custom-file-label" htmlFor="validatedCustomFile">
              Choose file...
            </label>
          )}

          <small className="invalid-feedback">Example invalid custom file feedback</small>
        </div>
      </div>
    );
  }
}

export { Fileuploader };



// WEBPACK FOOTER //
// ./src/components/Fileuploader.js